import React, { Component } from "react"
import { Popover } from "antd";
import classnames from "classnames";
import styles from './popoverControl.module.less'
import hexRgb from "hex-rgb";
import Icon from "@/components/Icon";

export default class PopoverControl extends Popover {
    state = {
        popoverVisible: false,
    }

    buttonClick = (button) => {
        button.onClick && button.onClick();
        this.setState({ popoverVisible: false });
    }

    content = () => {
        const { buttonList: proButtons, onDelete, columnCount: count } = this.props;
        let columnCount = count;
        if (!(columnCount && columnCount > 0)) {
            columnCount = 3;
        }
        let buttonList = [];
        let addButton = (button) => {
            let btArr = undefined;
            for (let index = 0; index < buttonList.length; index++) {
                let item = buttonList[index];
                if (item.length > 0 && item.length % columnCount !== 0) {
                    btArr = item;
                    break;
                }
            }
            if (btArr) {
                btArr.push(button);
            } else {
                btArr = [];
                btArr.push(button);
                buttonList.push(btArr);
            }
        }

        if (proButtons && proButtons.length > 0) {
            proButtons.forEach(element => addButton(element));
        }

        return (
            <div className={styles.moreDiv}>
                {buttonList.map(buttonRow => {
                    if (buttonRow.length > 0) {
                        return (
                            <div className={styles.buttonRow} >
                                {buttonRow.map(button => {
                                    let showIcon = undefined;
                                    if (Object.prototype.toString.call(button.icon) === "[object String]") {
                                        showIcon = button.antd ?
                                            <Icon antd type={button.icon} className={styles.icon} />
                                            :
                                            <Icon.Prop type={button.icon} className={styles.icon} />
                                    } else {
                                        showIcon = React.cloneElement(button.icon, { className: styles.icon })
                                    }
                                    return (
                                        <div className={styles.buttonDiv} onClick={e => this.buttonClick(button)}>
                                            {showIcon}
                                            < span className={styles.text} > {button.name}</span>
                                        </div>
                                    )
                                })
                                }
                            </div >
                        )
                    } else return ``;
                })}
                {
                    onDelete ?
                        <div className={styles.buttonRow} >
                            <div className={styles.delButtonDiv} onClick={onDelete}>
                                <Icon antd type={`delete`} className={styles.icon} />
                                <span className={styles.text}>{`删除`}</span>
                            </div>
                        </div>
                        : ``
                }
            </div >
        )
    }
    popoverVisibleChange = (visible) => {
        this.setState({ popoverVisible: visible });
    }
    render() {
        const { overlayClassName, children, ...parameter } = this.props;
        const { popoverVisible } = this.state;
        return (
            <Popover
                {...parameter}
                overlayClassName={styles.popover}
                content={this.content()}
                visible={popoverVisible}
                onVisibleChange={this.popoverVisibleChange}
            >
                {children}
            </Popover>
        )
    }
}